import { Component } from '@angular/core';
import { BookingStepService } from '../../services/booking-step.service';
import { BookingStepEnum } from '../../models/booking-step.enum';
import { BookingOrderService } from '../../services/booking-order.service';
import { OrderTypeEnum } from '../../../order/models/order-type.enum';

@Component({
  selector: 'app-booking-buy-more',
  templateUrl: './booking-buy-more.component.html',
  styleUrls: ['./booking-buy-more.component.css']
})
export class BookingBuyMoreComponent {


  constructor(
    private bookingStepService: BookingStepService,
    private bookingOrderService: BookingOrderService,
  ) {
  }

  onClickBuyMoreTickets(): void {
    this.bookingStepService.update(
      this.bookingOrderService.order && this.bookingOrderService.order.orderType === OrderTypeEnum.Single ?
        BookingStepEnum.SelectBookingSingleProducts
        :
        BookingStepEnum.SelectBookingEventProducts,
    );
  }
}
